/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useTranslation } from "react-i18next";
import { Box, Grid, Typography } from "@mui/material";
import { useState } from "react";
import ChargeFormTextField from "../ChargeFormTextField";
import BandCreditCard from "../band-credit-card/BandCreditCard";
import { formatCVC, formatCreditCardNumber, formatExpirationDate } from "../../utils/payment";

export default function Charge({ formHook }: any) {
  const { t } = useTranslation("applicationApp");
  const [selectedBand, setSelectedBand] = useState<any>("elo");

  const { watch, setValue } = formHook;

  const form = watch();

  const handleChangeCardCVC = (ev: { target: { value: any } }) =>
    setValue("cardCVC", formatCVC(ev.target.value));

  const handleChangeCardNumber = (ev: { target: { value: any } }) =>
    setValue("cardNumber", formatCreditCardNumber(ev.target.value));

  const handleChangeExpDate = (ev: { target: { value: any } }) =>
    setValue("cardDate", formatExpirationDate(ev.target.value));

  return (
    // <Box component="form" onSubmit={handleSubmit}>
    <Grid xs={12} md={8} item container className="justify-between">
      <Grid item xs={12}>
        <Typography
          variant="body2"
          className="border-solid border-b-2 pb-2 w-full uppercase"
          color="primary.main"
          borderColor="primary.main"
          component="p"
        >
          Dados de Cobrança
        </Typography>
      </Grid>
      <Grid xs={12} item>
        <ChargeFormTextField
          size="small"
          disabled={formHook.formState.isSubmitting}
          label="Pagamento por IUGU"
          fullWidth
          placeholder="4242 4242 4242 4242"
          fieldName="cardNumber"
          fieldControl={formHook.control}
          onChange={handleChangeCardNumber}
          verify={false}
          containerProps={{ withClassName: "mt-4 mr-3" }}
        />
        <Box className="flex flex-row my-4">
          <ChargeFormTextField
            size="small"
            disabled={formHook.formState.isSubmitting}
            fullWidth
            fieldName="cardFullName"
            placeholder="Nome no Cartão"
            fieldControl={formHook.control}
            verify={false}
          />
        </Box>

        <Box className="flex flex-row my-4">
          <ChargeFormTextField
            size="small"
            disabled={formHook.formState.isSubmitting}
            fieldName="cardDate"
            placeholder="05/2028"
            fieldControl={formHook.control}
            onChange={handleChangeExpDate}
            verify={false}
            containerProps={{
              withClassName: "w-32"
            }}
          />
          <ChargeFormTextField
            size="small"
            disabled={formHook.formState.isSubmitting}
            fieldName="cardCVC"
            fieldControl={formHook.control}
            onChange={handleChangeCardCVC}
            verify={false}
            placeholder="424"
            inputProps={{
              style: { textAlign: "center" }
            }}
            containerProps={{
              withClassName: "ml-4 w-24"
            }}
          />
        </Box>
        <BandCreditCard
          cartNumber={form.cardNumber}
          selectedBand={selectedBand}
          onSelectBand={setSelectedBand}
        />
      </Grid>
    </Grid>
    // </Box>
  );
}
